/**
 * ユーザ階層管理VO
 *
 * @export UserClassManagementModel
 * @class UserClassManagementModel
 */
export class UserClassManagementModel {

  // 操作専用用モデルかどうか
  public OnlyOperation = Boolean(false);
  // 追加されたモデルかどうか
  public Added = Boolean(false);
  // 権限によって操作可能か
  public Disabled = Boolean(false);

  // 部門コード
  public ClassCode = String('');
  // 部門名
  public ClassName = String('');

  // グループ長ユーザ(チェック選択)
  public GroupUserCheck = Boolean(false);
  // グループ長ユーザID
  public GroupUserId = String('');
  // グループ長ユーザID(変更前)
  public GroupUserIdOrigin = String('');
  // グループ長ユーザID(入力変更前の値：入力変更の度に更新)
  public GroupUserIdBeforeInput = String('');
  // グループ長ユーザID(エラー)
  public GroupUserError = Boolean(false);
  // グループ長ユーザ名
  public GroupUserName = String('');
  // グループ長ユーザ追加有無
  public GroupUserAdd = Boolean(false);
  // グループ長ユーザ編集有無
  public GroupUserEdit = Boolean(true);
  // 部門ごとグループ長の、初期表示時の固まりを表す識別子
  public GroupOriginSetId = String('');

  // 担当者ユーザ(チェック選択)
  public StaffUserCheck = Boolean(false);
  // 担当者ユーザID
  public StaffUserId = String('');
  // 担当者ユーザID(変更前)
  public StaffUserIdOrigin = String('');
  // 担当者ユーザID(入力変更前の値：入力変更の度に更新)
  public StaffUserIdBeforeInput = String('');
  // 担当者ユーザID(エラー)
  public StaffUserError = Boolean(false);
  // 担当者ユーザ名
  public StaffUserName = String('');
  // 担当者ユーザ追加有無
  public StaffUserAdd = Boolean(false);
  // 担当者ユーザ編集有無
  public StaffUserEdit = Boolean(true);
  // グループ長ごと担当者の、初期表示時の固まりを表す識別子
  public StaffOriginSetId = String('');

  // 代行者ユーザ(チェック選択)
  public AgentUserCheck = Boolean(false);
  // 代行者ユーザID
  public AgentUserId = String('');
  // 代行者ユーザID(変更前)
  public AgentUserIdOrigin = String('');
  // 代行者ユーザID(入力変更前の値：入力変更の度に更新)
  public AgentUserIdBeforeInput = String('');
  // 代行者ユーザID(エラー)
  public AgentUserError = Boolean(false);
  // 代行者ユーザ名
  public AgentUserName = String('');
  // 代行者ユーザ追加有無
  public AgentUserAdd = Boolean(false);
  // 代行者ユーザ編集有無
  public AgentUserEdit = Boolean(true);
  // 担当者ごと代行者の、初期表示時の固まりを表す識別子
  public AgentOriginSetId = String('');


  /**
   * 全階層を編集可否設定する
   *
   * @param {boolean} edit 編集可否
   * @returns {void}
   * @memberof UserClassManagementModel
   */
  public setEditAll(edit: boolean): void {
    this.GroupUserEdit = edit;
    this.StaffUserEdit = edit;
    this.AgentUserEdit = edit;
  }
}
